import { createStore, useAtom, useStore } from 'jotai';
import { FC, useEffect, useState } from 'react';
import { EURO_COUNTRY_LIST, getCookieChoice } from '~/components/cookie-banner/utils';
import { $UserAgent, $Locale } from '@lemon8/web-app-shared/atom';
import { $BottomReflowShow } from '~/models/portal/bottom-reflow';
import { $CookiePanelOpen } from '~/models/portal/cookie';
import { $LandingModalOpen } from '~/models/portal/landing-modal';

const needShowCookieBanner = (store: ReturnType<typeof createStore>): boolean => {
  const { region, ipRegion } = store.get($Locale);
  const { isBot } = store.get($UserAgent);

  const cookieChoices = getCookieChoice();
  const isStrictRegion =
    EURO_COUNTRY_LIST.includes(ipRegion.toUpperCase()) || EURO_COUNTRY_LIST.includes(region.toUpperCase());

  if (JSON.stringify(cookieChoices) !== '{}' || isBot) {
    return false;
  } else if (isStrictRegion) {
    return true;
  }
  return false;
};

const needShowLandingModal = (store: ReturnType<typeof createStore>): boolean => {
  const { isMobile, isBot } = store.get($UserAgent);

  const keyPrefix = 'seo_page_first_open_cta';
  const dateToday = ((): string => {
    const today = new Date();
    const date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    return date;
  })();

  if (!isMobile || isBot) {
    return false;
  }

  return window.localStorage.getItem(`${keyPrefix}_${dateToday}`) !== '1';
};

const needShowReflowButton = (store: ReturnType<typeof createStore>): boolean => {
  const { isMobile } = store.get($UserAgent);
  return isMobile;
};

// TODO more abstract...
export const LayerManager: FC = () => {
  const store = useStore();

  // first check cookie
  const [needCookie, setNeedCookie] = useState(false);
  const [cookieStatus, setCookieStatus] = useState<0 | 1 | 2>(0);
  const [needLanding, setNeedLanding] = useState(false);
  const [landingStatus, setLandingStatus] = useState<0 | 1 | 2>(0);
  const [needReflowButton, setNeedReflowButton] = useState(false);
  const [reflowButtonStatus, setReflowButtonStatus] = useState<0 | 1 | 2>(0);

  const [cookieShow, setCookieShow] = useAtom($CookiePanelOpen);
  const [landingShow, setLandingShow] = useAtom($LandingModalOpen);
  const [reflowShow, setReflowShow] = useAtom($BottomReflowShow);

  useEffect(() => {
    setNeedCookie(needShowCookieBanner(store));
    setNeedLanding(needShowLandingModal(store));
    setNeedReflowButton(needShowReflowButton(store));
  }, []);

  useEffect(() => {
    if (cookieShow && cookieStatus === 0) {
      setCookieStatus(1);
    }
    if (!cookieShow && cookieStatus === 1) {
      setCookieStatus(2);
    }
  }, [cookieShow, cookieStatus]);

  useEffect(() => {
    if (landingShow && landingStatus === 0) {
      setLandingStatus(1);
    }
    if (!landingShow && landingStatus === 1) {
      setLandingStatus(2);
    }
  }, [landingShow, landingStatus]);

  useEffect(() => {
    if (reflowShow && reflowButtonStatus === 0) {
      setReflowButtonStatus(1);
    }
    if (!reflowShow && reflowButtonStatus === 1) {
      setReflowButtonStatus(2);
    }
  }, [reflowShow, reflowButtonStatus]);

  useEffect(() => {
    if (needCookie && cookieStatus === 0) {
      setCookieShow(true);
    }

    if (needCookie && cookieStatus < 2) {
      return;
    }

    if (needLanding && landingStatus === 0) {
      setLandingShow(true);
    }

    if ((needCookie && cookieStatus < 2) || (needLanding && landingStatus < 2)) {
      return;
    }

    if (needReflowButton && reflowButtonStatus === 0) {
      setReflowShow(true);
    }
  }, [needCookie, needLanding, needReflowButton, cookieStatus, landingStatus, reflowButtonStatus]);

  return null;
};
